
import React, { useEffect, useState } from "react";
// import AppContext from '../contexts/AppContext';
import CityInterface from "../interfaces/CityInterface";
import StateInterface from "../interfaces/StateInterface";

import { Alert, Box, Breadcrumbs, Button, Card, CircularProgress, Container, FormControl, Grid, InputLabel, Link, List, ListItem, ListItemText, MenuItem, Select, SelectChangeEvent, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import functionsCoverageArea from "../services/coverageArea.service";
import CoverageAreaInterface from "../interfaces/CoverageAreaInterface";
// import NotyfContext from "../contexts/NotyfContext";

const CoverageArea = () => {
	// const appContext = useContext(AppContext);
	// const notyf = useContext(NotyfContext);
	const [states, setStates] = useState<StateInterface[]>();
	const [cities, setCities] = useState<CityInterface[]>();
	const [selectedState, setSelectedState] = useState<StateInterface>();
	const [selectedCity, setSelectedCity] = useState<CityInterface>();
	const [coverageAreas, setCoverageAreas] = useState<CoverageAreaInterface[]>();
	const [isLoadingCoverageAreas, setIsLoadingCoverageAreas] = useState<boolean>(false);
	// const [isChangingValue, setIsChangingValue] = useState<boolean>(false);

	const handleChangeState = (event: SelectChangeEvent) => {
		setSelectedState(states?.find((state) => {
			return state._id === event.target.value as string
		}));
	};

	const handleChangeCity = (event: SelectChangeEvent) => {
		setSelectedCity(cities?.find((city) => {
			return city._id === event.target.value as string
		}))
	};

	const handleClickFilterButton = () => {
		// console.log("TESTE");
		setIsLoadingCoverageAreas(true);
		if (selectedState !== undefined && selectedCity !== undefined){
			setTimeout(() => {
				// console.log("2 segundos")
				functionsCoverageArea.getCoverageAreasByFilter(selectedState?.name, selectedCity?.name)
				.then((response) => {
					// console.log(response.data);
					setCoverageAreas(response.data.coverageAreas);
					// setIsChangingValue(false);
				}).catch((error) => {
					console.log(error);
				}).finally(() => {
					// console.log("TERMINOU");
					setIsLoadingCoverageAreas(false);
				});
			}, 500)
		}
	}

	// const handleCoverageAreaUpdate = (state: string, city: string, coverageArea: string, price: number, enabled: boolean) => {
	// 	functionsCoverageArea.updateCoverageArea(
	// 		state,
	// 		city,
	// 		coverageArea,
	// 		price,
	// 		enabled
	// 	).then((response) => {
	// 		// console.log(response.data);
	// 		notyf.success({
	// 			message: "Área de cobertura atualizada.",
	// 			position: {
	// 				x: "right",
	// 				y: "top"
	// 			}
	// 		});
	// 		// handleClickFilterButton();
	// 	}).catch((error) => {
	// 		notyf.error({
	// 			message: "Erro ao atualizar a área de cobertura.",
	// 			position: {
	// 				x: "right",
	// 				y: "top"
	// 			}
	// 		});
	// 		console.log(error);
	// 	}).finally(() => {
	// 		setIsChangingValue(false);
	// 	});
	// }

	useEffect(() => {
		functionsCoverageArea.getStatesByCountry()
		.then((response) => {
			// console.log(response.data);
			setStates(response.data.states);
		}).catch((error) => {
			console.log(error);
		});
	}, []);

	useEffect(() => {
		if (selectedState !== undefined){
			functionsCoverageArea.getCitiesByState(selectedState?._id)
			.then((response) => {
				// console.log(response.data);
				setCities(response.data.cities);
			}).catch((error) => {
				console.log(error);
			})
		}
	}, [selectedState]);
	
	return (
		<>
			<Box m={2}>
				<Breadcrumbs aria-label="breadcrumb">
					<Link underline="hover" color="inherit" href="/">
						Página inicial
					</Link>
					<Typography color="text.primary" aria-current="page">Áreas de cobertura</Typography>
				</Breadcrumbs>
			</Box>
			<Container>
				<Grid container spacing={2} mt={2} mb={10}>
					<Grid item lg={12} md={12} xs={12}>
						<Typography variant="h4">
							Áreas de cobertura
						</Typography>
						<Typography variant="subtitle1">
							Gerência das áreas de cobertura do seu negócio. Visualize os bairros por Estado e Cidade.
						</Typography>
					</Grid>
					<Grid item lg={12} md={12} xs={12}>
						<Card
							style={{
								backgroundColor: "#FFF",
								borderRadius: 16,
								padding: 24,
								boxShadow: "rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px"
							}}
						>
							<Grid container spacing={2}>
								<Grid item lg={4} md={4} xs={12}>
									<FormControl fullWidth>
										<InputLabel id="demo-simple-select-label">Estado</InputLabel>
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											value={selectedState?._id ?? ""}
											label="Age"
											onChange={handleChangeState}
											size="small"
											error={selectedState === undefined}
										>
											{states?.map((state: StateInterface) => (
												<MenuItem key={state._id} value={state._id}>{state.name}</MenuItem>
											))}
										</Select>
									</FormControl>
								</Grid>
								<Grid item lg={4} md={4} xs={12}>
									<FormControl fullWidth>
										<InputLabel id="demo-simple-select-label">Cidade</InputLabel>
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											value={selectedCity?._id ?? ""}
											label="Age"
											onChange={handleChangeCity}
											size="small"
											disabled={cities === undefined || cities?.length === 0}
										>
											{cities?.map((city: CityInterface) => (
												<MenuItem key={city._id} value={city._id}>{city.name}</MenuItem>
											))}
											{/* <MenuItem value={10}>Ten</MenuItem>
											<MenuItem value={20}>Twenty</MenuItem>
											<MenuItem value={30}>Thirty</MenuItem> */}
										</Select>
									</FormControl>
								</Grid>
								<Grid item lg={4} md={4} xs={12}>
									<Button
										disabled={selectedState === undefined || selectedCity === undefined || isLoadingCoverageAreas}
										variant="contained"
										fullWidth
										onClick={() => {
											handleClickFilterButton()
										}}
									>
										Filtrar
									</Button>
								</Grid>
							</Grid>
						</Card>
					</Grid>
					
					<Grid item lg={12} md={12} xs={12}>
						{isLoadingCoverageAreas ? <>
							<Box mt={5} mb={5} justifyContent={"center"} alignContent={"center"} textAlign={"center"}>
								<CircularProgress size={100} />
							</Box>
						</> : <>
							{coverageAreas !== null && coverageAreas !== undefined && coverageAreas?.length > 0 ? <>
								<Card
									style={{
										backgroundColor: "#FFF",
										borderRadius: 16,
										// padding: 24,
										boxShadow: "rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px"
									}}
								>
									<Box p={2}>
										<Alert severity="info">
											Entre em contato com o suporte para editar as áreas de cobertura e o preço.
										</Alert>
										<Typography variant="subtitle1" align="right">
											{`${coverageAreas.length} áreas de cobertura encontradas`}
										</Typography>
									</Box>
									
									<Box sx={{ display: { xs: 'block', md: 'none', lg: 'none' } }}>
										<List dense>
											{coverageAreas.map((coverageArea: CoverageAreaInterface, index: number) => (
												<ListItem
													key={coverageArea._id}
													secondaryAction={
														<Switch
															disabled
															checked={coverageArea.parameters.length > 0 ? coverageArea.parameters[0].enabled : false}
															inputProps={{ 'aria-label': 'controlled' }}
														/>
													}
												>
													<ListItemText
														primary={`${coverageArea.name}`}
														secondary={
															coverageArea.parameters.length > 0 
															? coverageArea.parameters[0].price.toLocaleString("pt-BR", {
																style: "currency",
																currency: "BRL"
															})
															: Number(1).toLocaleString("pt-BR", {
																style: "currency",
																currency: "BRL"
															})
														}
													/>
												</ListItem>
											))}
										</List>
									</Box>
									
									<Box sx={{ display: { xs: 'none', md: 'block', lg: 'block' } }}>
										<TableContainer>
											<Table stickyHeader size="small">
												<TableHead>
													<TableRow>
														<TableCell>Bairro / Área</TableCell>
														<TableCell align="center">Taxa de Entrega</TableCell>
														<TableCell align="right">Habilitado</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{coverageAreas.map((coverageArea: CoverageAreaInterface, index: number) => (
														<TableRow key={coverageArea._id}>
															<TableCell component="th" scope="row">
																{coverageArea.name}
															</TableCell>
															<TableCell align="center">
																<TextField
																	disabled
																	variant={"outlined"}
																	size={"small"}
																	autoComplete={"off"}
																	type={"number"}
																	value={coverageArea.parameters.length > 0 ? coverageArea.parameters[0].price : 1}
																	onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
																		// console.log(event.target.value);
																		let coverageAreasAux = [...coverageAreas];
																		coverageAreasAux[index] = {
																			...coverageAreasAux[index],
																			parameters: [{
																				enabled: coverageArea.parameters.length > 0 ? coverageArea.parameters[0].enabled : false,
																				price: Number(event.target.value),
																				vehicleCategory: 2
																			}],
																		}
																		setCoverageAreas(coverageAreasAux);
																	}}
																/>
															</TableCell>
															<TableCell align="right">
																<Switch
																	disabled
																	checked={coverageArea.parameters.length > 0 ? coverageArea.parameters[0].enabled : false}
																	inputProps={{ 'aria-label': 'controlled' }}
																/>
															</TableCell>
														</TableRow>
													))}
												</TableBody>
											</Table>
										</TableContainer>
									</Box>
								</Card>
							</> : <>
								<Alert severity="warning">
									Nenhuma área encontrada ou selecionada.
								</Alert>
							</>}
						</>}
					</Grid>
				</Grid>
			</Container>
		</>
	)
};

export default CoverageArea;